import catalogModule from '../catalogModule';

function catalogPage(catalogConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: catalogConstants.templateUrls.catalogPageTemplate
  };
}

catalogModule.directive('catalogPage', catalogPage);

export default catalogPage;
